export const GENDERS = ['Male', 'Female'];

export const GPTSubjects = [
  {
    id: 1,
    shortName: 'ENGLISH',
    name: 'ENGLISH_AI',
    nameEn: 'English AI',
    nameAr: '⁠الانجليزية',
    desc: 'ENGLISH_AI_DESC',
    img: 'assets/gpt/english.svg',
    isAnimated: false,
    openStores: ['school', 'essential'],
  },
  {
    id: 2,
    shortName: 'ESSAY',
    name: 'ESSAY_BOOK_REPORT_AI',
    nameEn: 'Essay/Book Report AI',
    nameAr: '⁠المقالات و تقارير الكتب',
    desc: 'ESSAY_BOOK_REPORT_AI_DESC',
    img: 'assets/gpt/essay.svg',
    isAnimated: false,
    openStores: ['school', 'essential'],
  },
  {
    id: 3,
    shortName: 'HISTORY',
    name: 'HISTORY_SOCIAL_STUDIES_AI',
    nameEn: 'History / Social Studies AI',
    nameAr: '⁠التاريخ / الدراسات الاجتماعية',
    desc: 'HISTORY_SOCIAL_STUDIES_AI_DESC',
    img: 'assets/gpt/history.svg',
    isAnimated: false,
    openStores: ['school', 'essential'],
  },
  {
    id: 4,
    shortName: 'SCIENCE',
    name: 'SCIENCE_AI',
    nameEn: 'Science AI',
    nameAr: '⁠العلوم',
    desc: 'SCIENCE_AI_DESC',
    img: 'assets/gpt/science.svg',
    isAnimated: false,
    openStores: ['school', 'essential'],
  },
  {
    id: 5,
    shortName: 'MATH',
    name: 'MATH_AI_BETA',
    nameEn: 'Math AI (beta)',
    nameAr: 'الذكاء الاصطناعي للرياضيات (تجريبي)',
    desc: 'MATH_AI_BETA_DESC',
    img: 'assets/gpt/math.svg',
    isAnimated: false,
    openStores: ['school', 'essential'],
  },
];

export const GPTFriendlyAI = {
  id: 6,
  shortName: 'FRIENDLY_AI',
  name: 'FRIENDLY_AI',
  nameEn: 'Friendly AI',
  nameAr: 'الذكاء الاصطناعي الصديق',
  desc: 'FRIENDLY_AI_DESC',
  img: 'assets/gpt/friendly.svg',
  isAnimated: false,
  openStores: ['school'],
};

export const GPTSchoolStores = [
  {
    id: 21,
    parent: 'SCIENCE_HUB',
    img: 'assets/gpt/chemistry.svg',
    name: 'CHEMISTRY',
    nameEn: 'Chemistry',
    nameAr: 'الكيمياء',
    description: 'FRIENDLY_CHEMISTRY_GUIDE_STUDENTS',
    openStores: ['school'],
  },
  {
    id: 22,
    parent: 'SCIENCE_HUB',
    img: 'assets/gpt/botany.svg',
    name: 'BOTANY',
    nameEn: 'Botany',
    nameAr: 'علم النبات',
    description: 'BOTANY_LEARNING_ASSISTANT_MEMORY',
    openStores: ['school'],
  },
  {
    id: 23,
    parent: 'SCIENCE_HUB',
    img: 'assets/gpt/zoology.svg',
    name: 'ZOOLOGY',
    nameEn: 'Zoology',
    nameAr: 'علم الحيوان',
    description: 'FRIENDLY_GUIDE_ANIMAL_BIOLOGY',
    openStores: ['school'],
  },
  {
    id: 9,
    parent: 'SCIENCE_HUB',
    img: 'assets/gpt/science-lab.svg',
    name: 'SCIENCELAB_ASSISTANT',
    nameEn: 'ScienceLab Assistant',
    nameAr: 'مساعد مختبر العلوم',
    description: 'LAB_EXPERIMENTS_DATA_ANALYSIS',
    openStores: ['school'],
  },
  {
    id: 11,
    parent: 'SCIENCE_HUB',
    img: 'assets/gpt/math-master.svg',
    name: 'MATHMASTER_PRO',
    nameEn: 'MathMaster Pro',
    nameAr: 'ماستر الرياضيات',
    description: 'PATIENT_KNOWLEDGEABLE_MATH_TEACHER',
    openStores: ['school'],
  },
  {
    id: 14,
    parent: 'SCIENCE_HUB',
    img: 'assets/gpt/physics.svg',
    name: 'PHYSICS_PRO',
    nameEn: 'Physics Pro',
    nameAr: 'برو الفيزياء',
    description: 'CLEAR_ENGAGING_PHYSICS_EXPERT',
    openStores: ['school'],
  },
  {
    id: 15,
    parent: 'EXAM_PREP_PAL',
    img: 'assets/gpt/sat.svg',
    name: 'SAT_PREP_PAL',
    nameEn: 'SAT Prep Pal',
    nameAr: 'رفيق تحضير SAT',
    description: 'DEDICATED_SAT_EXAM_TUTOR',
    openStores: ['school'],
  },
  {
    id: 16,
    parent: 'EXAM_PREP_PAL',
    img: 'assets/gpt/act.svg',
    name: 'ACT_ACE',
    nameEn: 'ACT Ace',
    nameAr: 'نجم ACT',
    description: 'EXPERT_VARIOUS_ACADEMIC_SUBJECTS',
    openStores: ['school'],
  },
  {
    id: 17,
    parent: 'EXAM_PREP_PAL',
    img: 'assets/gpt/ielts.svg',
    name: 'IELTS',
    nameEn: 'IELTS',
    nameAr: 'IELTS',
    description: 'FOCUSED_IELTS_EXAM_ASSISTANT',
    openStores: ['school'],
  },
  {
    id: 18,
    parent: 'EXAM_PREP_PAL',
    img: 'assets/gpt/gre.svg',
    name: 'GRE_PREP_PAL',
    nameEn: 'GRE Prep Pal',
    nameAr: 'رفيق تحضير GRE',
    description: 'EXAM_GUIDE_STRATEGY_ADVISOR',
    openStores: ['school'],
  },
  {
    id: 19,
    parent: 'EXAM_PREP_PAL',
    img: 'assets/gpt/gmat.svg',
    name: 'GMAT_PREP_PAL',
    nameEn: 'GMAT Prep Pal',
    nameAr: 'رفيق تحضير GMAT',
    description: 'GMAT_PREPARATION_INSIGHTS',
    openStores: ['school'],
  },
  {
    id: 20,
    parent: 'EXAM_PREP_PAL',
    img: 'assets/gpt/toefl.svg',
    name: 'TOEFL_PREP_PAL',
    nameEn: 'TOEFL Prep Pal',
    nameAr: 'رفيق تحضير TOEFL',
    description: 'ENGLISH_MASTERY_GUIDE_ACADEMIC_SUCCESS',
    openStores: ['school'],
  },
  {
    id: 7,
    parent: 'HUMANITIES',
    img: 'assets/gpt/econ.svg',
    name: 'ECON_EXPERT',
    nameEn: 'EconExpert',
    nameAr: 'خبير الاقتصاد',
    description: 'CLEAR_EXPLANATION_ECONOMICS',
    openStores: ['school'],
  },
  {
    id: 8,
    parent: 'HUMANITIES',
    img: 'assets/gpt/geography.svg',
    name: 'GEOGRAPHY_EXPLORER',
    nameEn: 'GeographyExplorer',
    nameAr: 'مستكشف الجغرافيا',
    description: 'GUIDE_WORLD_GEOGRAPHY',
    openStores: ['school'],
  },
  {
    id: 10,
    parent: 'HUMANITIES',
    img: 'assets/gpt/language-lab.svg',
    name: 'LANGUAGELAB_PRO',
    nameEn: 'LanguageLab Pro',
    nameAr: 'مختبر اللغات برو',
    description: 'LANGUAGE_SKILL_ENHANCER_PRONUNCIATION',
    openStores: ['school'],
  },
  {
    id: 24,
    parent: 'TIME_SAVERS',
    img: 'assets/gpt/ask-pdf.svg',
    name: 'ASK_YOUR_PDF',
    nameEn: 'AskYourPDF',
    nameAr: 'اسأل PDF الخاص بك',
    description: 'EXTRACTS_INSIGHTS_PDF_DOCUMENTS',
    openStores: ['school'],
  },
  // {
  //   id: 25,
  //   parent: 'TIME_SAVERS',
  //   img: 'assets/gpt/video-summarize.svg',
  //   name: 'VIDEO_SUMMARIZER',
  //   nameEn: 'Video Summarizer',
  //   nameAr: 'Video Summarizer',
  //   description: 'SUMMARIZES_VIDEOS_STUDY_RESEARCH',
  //   openStores: ['school'],
  // },
  {
    id: 12,
    parent: 'MISC',
    img: 'assets/gpt/career.svg',
    name: 'CAREER_360',
    nameEn: 'Career 360',
    nameAr: 'مسيرة 360',
    description: 'CAREER_EXPLORATION_SKILL_DEVELOPMENT',
    openStores: ['school'],
  },
  {
    id: 13,
    parent: 'MISC',
    img: 'assets/gpt/scholar.svg',
    name: 'SCHOLAR_AI',
    nameEn: 'ScholarAI',
    nameAr: 'باحث الذكاء الاصطناعي',
    description: 'SIMPLIFYING_COMPLEX_RESEARCH',
    openStores: ['school'],
  },
];

export const GPTUniversityStores = [
  {
    id: 26,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine1.svg',
    name: 'ANATOMEASE_TUTOR',
    nameEn: 'Human Anatomy',
    nameAr: 'علم التشريح البشري',
    description: 'ANATOMEASE_TUTOR_DESC',
    openStores: ['university'],
  },
  {
    id: 27,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine2.svg',
    name: 'PHYSIOPHRIEND',
    nameEn: 'Physiology',
    nameAr: 'علم وظائف الأعضاء',
    description: 'PHYSIOPHRIEND_DESC',
    openStores: ['university'],
  },
  {
    id: 28,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine3.svg',
    name: 'BIOCHEMBUDDY',
    nameEn: 'Biochemistry',
    nameAr: 'الكيمياء الحيوية',
    description: 'BIOCHEMBUDDY_DESC',
    openStores: ['university'],
  },
  {
    id: 29,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine4.svg',
    name: 'PHARMAFACILITATOR',
    nameEn: 'Pharmacology',
    nameAr: 'علم الأدوية',
    description: 'PHARMAFACILITATOR_DESC',
    openStores: ['university'],
  },
  {
    id: 30,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine5.svg',
    name: 'PATHOPIONEER',
    nameEn: 'Pathology',
    nameAr: 'علم الأمراض',
    description: 'PATHOPIONEER_DESC',
    openStores: ['university'],
  },
  {
    id: 31,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine6.svg',
    name: 'MICROBEMASTER',
    nameEn: 'Microbiology',
    nameAr: 'علم الأحياء الدقيقة',
    description: 'MICROBEMASTER_DESC',
    openStores: ['university'],
  },
  {
    id: 32,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine7.svg',
    name: 'FORENSICFRONTIERS_GUIDE',
    nameEn: 'Forensic Medicine',
    nameAr: 'الطب الشرعي',
    description: 'FORENSICFRONTIERS_GUIDE_DESC',
    openStores: ['university'],
  },
  {
    id: 33,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine8.svg',
    name: 'COMMUNICARE_MENTOR',
    nameEn: 'Communication Skills in Medicine',
    nameAr: 'مهارات التواصل الطبي',
    description: 'COMMUNICARE_MENTOR_DESC',
    openStores: ['university'],
  },
  {
    id: 34,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine9.svg',
    name: 'PEDIAPAL',
    nameEn: 'Pediatrics',
    nameAr: 'طب الأطفال',
    description: 'PEDIAPAL_DESC',
    openStores: ['university'],
  },
  {
    id: 35,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine10.svg',
    name: 'OBGYNORACLE',
    nameEn: 'Obstetrics and Gynecology',
    nameAr: 'طب النساء والتوليد',
    description: 'OBGYNORACLE_DESC',
    openStores: ['university'],
  },
  {
    id: 36,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine11.svg',
    name: 'SURGICALSTRATEGIST',
    nameEn: 'Surgery',
    nameAr: 'الجراحة',
    description: 'SURGICALSTRATEGIST_DESC',
    openStores: ['university'],
  },
  {
    id: 37,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine12.svg',
    name: 'MEDIMENTOR',
    nameEn: 'General/Internal Medicine',
    nameAr: 'الطب الباطني العام',
    description: 'MEDIMENTOR_DESC',
    openStores: ['university'],
  },
  {
    id: 38,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine13.svg',
    name: 'DERMOCOMPANION',
    nameEn: 'Dermatology',
    nameAr: 'الأمراض الجلدية',
    description: 'DERMOCOMPANION_DESC',
    openStores: ['university'],
  },
  {
    id: 39,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine14.svg',
    name: 'PSYCHEPILOT',
    nameEn: 'Psychiatry',
    nameAr: 'الطب النفسي',
    description: 'PSYCHEPILOT_DESC',
    openStores: ['university'],
  },
  {
    id: 40,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine15.svg',
    name: 'RADIOLOGYREVEALER',
    nameEn: 'Radiology',
    nameAr: 'الأشعة',
    description: 'RADIOLOGYREVEALER_DESC',
    openStores: ['university'],
  },
  {
    id: 41,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine16.svg',
    name: 'OPHTHALMOGUIDE',
    nameEn: 'Ophthalmology',
    nameAr: 'طب العيون',
    description: 'OPHTHALMOGUIDE_DESC',
    openStores: ['university'],
  },
  {
    id: 42,
    parent: 'MEDICINE',
    img: 'assets/gpt/medicine17.svg',
    name: 'ENTENLIGHTENER',
    nameEn: 'ENT (Otorhinolaryngology)',
    nameAr: 'الأنف والأذن والحنجرة',
    description: 'ENTENLIGHTENER_DESC',
    openStores: ['university'],
  },
  {
    id: 43,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering1.svg',
    name: 'MECHANOMENTOR',
    nameEn: 'Mechanical Engineering',
    nameAr: 'الهندسة الميكانيكية',
    description: 'MECHANOMENTOR_DESC',
    openStores: ['university'],
  },
  {
    id: 44,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering2.svg',
    name: 'ELECTROENLIGHTENER',
    nameEn: 'Electrical Engineering',
    nameAr: 'الهندسة الكهربائية',
    description: 'ELECTROENLIGHTENER_DESC',
    openStores: ['university'],
  },
  {
    id: 45,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering3.svg',
    name: 'CIVILITYSCULPTOR',
    nameEn: 'Civil Engineering',
    nameAr: 'الهندسة المدنية',
    description: 'CIVILITYSCULPTOR_DESC',
    openStores: ['university'],
  },
  {
    id: 46,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering4.svg',
    name: 'CHEMCRAFTER',
    nameEn: 'Chemical Engineering',
    nameAr: 'الهندسة الكيميائية',
    description: 'CHEMCRAFTER_DESC',
    openStores: ['university'],
  },
  {
    id: 47,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering5.svg',
    name: 'AEROARCHITECT',
    nameEn: 'Aerospace Engineering',
    nameAr: 'هندسة الطيران والفضاء',
    description: 'AEROARCHITECT_DESC',
    openStores: ['university'],
  },
  {
    id: 48,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering6.svg',
    name: 'COMPUCRAFT_ENGINEER',
    nameEn: 'Computer Engineering',
    nameAr: 'هندسة الحاسوب',
    description: 'COMPUCRAFT_ENGINEER_DESC',
    openStores: ['university'],
  },
  {
    id: 49,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering7.svg',
    name: 'BIOBIONIC_GUIDE',
    nameEn: 'Biomedical Engineering',
    nameAr: 'الهندسة الطبية الحيوية',
    description: 'BIOBIONIC_GUIDE_DESC',
    openStores: ['university'],
  },
  {
    id: 50,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering8.svg',
    name: 'INDUSTRIOSTREAMLINER',
    nameEn: 'Industrial Engineering',
    nameAr: 'الهندسة الصناعية',
    description: 'INDUSTRIOSTREAMLINER_DESC',
    openStores: ['university'],
  },
  {
    id: 51,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering9.svg',
    name: 'ECOENGINE_INNOVATOR',
    nameEn: 'Environmental Engineering',
    nameAr: 'الهندسة البيئية',
    description: 'ECOENGINE_INNOVATOR_DESC',
    openStores: ['university'],
  },
  {
    id: 52,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering10.svg',
    name: 'MATERIALMAESTRO',
    nameEn: 'Materials Engineering',
    nameAr: 'هندسة المواد',
    description: 'MATERIALMAESTRO_DESC',
    openStores: ['university'],
  },
  {
    id: 53,
    parent: 'ENGINEERING',
    img: 'assets/gpt/engineering11.svg',
    name: 'PETROPRODIGY',
    nameEn: 'Petroleum Engineering',
    nameAr: 'هندسة البترول',
    description: 'PETROPRODIGY_DESC',
    openStores: ['university'],
  },
  {
    id: 54,
    parent: 'MATHS',
    img: 'assets/gpt/math1.svg',
    name: 'ALGEBRA_AVATAR',
    nameEn: 'Algebra',
    nameAr: 'الجبر',
    description: 'ALGEBRA_AVATAR_DESC',
    openStores: ['university'],
  },
  {
    id: 55,
    parent: 'MATHS',
    img: 'assets/gpt/math2.svg',
    name: 'CALCULUS_COMPANION',
    nameEn: 'Calculus',
    nameAr: 'التفاضل والتكامل',
    description: 'CALCULUS_COMPANION_DESC',
    openStores: ['university'],
  },
  {
    id: 56,
    parent: 'MATHS',
    img: 'assets/gpt/math3.svg',
    name: 'GEOMETRY_GENIUS',
    nameEn: 'Geometry',
    nameAr: 'الهندسة',
    description: 'GEOMETRY_GENIUS_DESC',
    openStores: ['university'],
  },
  {
    id: 57,
    parent: 'MATHS',
    img: 'assets/gpt/math4.svg',
    name: 'STATISTICS_SAGE',
    nameEn: 'Statistics',
    nameAr: 'الإحصاء',
    description: 'STATISTICS_SAGE_DESC',
    openStores: ['university'],
  },
  {
    id: 58,
    parent: 'MATHS',
    img: 'assets/gpt/math5.svg',
    name: 'APPLIED_MATH_MAGICIAN',
    nameEn: 'Applied Mathematics',
    nameAr: 'الرياضيات التطبيقية',
    description: 'APPLIED_MATH_MAGICIAN_DESC',
    openStores: ['university'],
  },
  {
    id: 59,
    parent: 'PHYSICS',
    img: 'assets/gpt/physics1.svg',
    name: 'MECHANICS_MAESTRO',
    nameEn: 'Mechanics',
    nameAr: 'الميكانيكا',
    description: 'MECHANICS_MAESTRO_DESC',
    openStores: ['university'],
  },
  {
    id: 60,
    parent: 'PHYSICS',
    img: 'assets/gpt/physics2.svg',
    name: 'ELECTROMAGNET_ENCHANTER',
    nameEn: 'Electromagnetism',
    nameAr: 'الكهرومغناطيسية',
    description: 'ELECTROMAGNET_ENCHANTER_DESC',
    openStores: ['university'],
  },
  {
    id: 61,
    parent: 'PHYSICS',
    img: 'assets/gpt/physics3.svg',
    name: 'QUANTUM_QUELL',
    nameEn: 'Quantum Physics',
    nameAr: 'الفيزياء الكمية',
    description: 'QUANTUM_QUELL_DESC',
    openStores: ['university'],
  },
  {
    id: 62,
    parent: 'PHYSICS',
    img: 'assets/gpt/physics4.svg',
    name: 'THERMODYNAMICS_DETECTIVE',
    nameEn: 'Thermodynamics',
    nameAr: 'الديناميكا الحرارية',
    description: 'THERMODYNAMICS_DETECTIVE_DESC',
    openStores: ['university'],
  },
  {
    id: 63,
    parent: 'PHYSICS',
    img: 'assets/gpt/physics5.svg',
    name: 'ASTROAIDE',
    nameEn: 'Astrophysics',
    nameAr: 'الفيزياء الفلكية',
    description: 'ASTROAIDE_DESC',
    openStores: ['university'],
  },
  {
    id: 64,
    parent: 'CHEMISTRY_',
    img: 'assets/gpt/chemistry1.svg',
    name: 'ORGANIC_ORACLE',
    nameEn: 'Organic Chemistry',
    nameAr: 'الكيمياء العضوية',
    description: 'ORGANIC_ORACLE_DESC',
    openStores: ['university'],
  },
  {
    id: 65,
    parent: 'CHEMISTRY_',
    img: 'assets/gpt/chemistry2.svg',
    name: 'INORGANIC_INTELLECT',
    nameEn: 'Inorganic Chemistry',
    nameAr: 'الكيمياء غير العضوية',
    description: 'INORGANIC_INTELLECT_DESC',
    openStores: ['university'],
  },
  {
    id: 66,
    parent: 'CHEMISTRY_',
    img: 'assets/gpt/chemistry3.svg',
    name: 'PHYSICAL_CHEMISTRY_PIONEER',
    nameEn: 'Physical Chemistry',
    nameAr: 'الكيمياء الفيزيائية',
    description: 'PHYSICAL_CHEMISTRY_PIONEER_DESC',
    openStores: ['university'],
  },
  {
    id: 67,
    parent: 'CHEMISTRY_',
    img: 'assets/gpt/chemistry4.svg',
    name: 'ANALYTICAL_ALCHEMIST',
    nameEn: 'Analytical Chemistry',
    nameAr: 'الكيمياء التحليلية',
    description: 'ANALYTICAL_ALCHEMIST_DESC',
    openStores: ['university'],
  },
  {
    id: 68,
    parent: 'CHEMISTRY_',
    img: 'assets/gpt/chemistry5.svg',
    name: 'BIOCHEM_BEACON',
    nameEn: 'Biochemistry',
    nameAr: 'الكيمياء الحيوية',
    description: 'BIOCHEM_BEACON_DESC',
    openStores: ['university'],
  },
  {
    id: 69,
    parent: 'BIOLOGY',
    img: 'assets/gpt/biology1.svg',
    name: 'CELL_BIOLOGY_BEACON',
    nameEn: 'Cell Biology',
    nameAr: 'علم الأحياء الخلوية',
    description: 'CELL_BIOLOGY_BEACON_DESC',
    openStores: ['university'],
  },
  {
    id: 70,
    parent: 'BIOLOGY',
    img: 'assets/gpt/biology2.svg',
    name: 'GENETICS_GUIDE',
    nameEn: 'Genetics',
    nameAr: 'علم الوراثة',
    description: 'GENETICS_GUIDE_DESC',
    openStores: ['university'],
  },
  {
    id: 71,
    parent: 'BIOLOGY',
    img: 'assets/gpt/biology3.svg',
    name: 'EVOENGINE',
    nameEn: 'Evolutionary Biology',
    nameAr: 'علم الأحياء التطوري',
    description: 'EVOENGINE_DESC',
    openStores: ['university'],
  },
  {
    id: 72,
    parent: 'BIOLOGY',
    img: 'assets/gpt/biology4.svg',
    name: 'ECOEXPLORER',
    nameEn: 'Ecology',
    nameAr: 'علم البيئة',
    description: 'ECOEXPLORER_DESC',
    openStores: ['university'],
  },
  {
    id: 73,
    parent: 'BIOLOGY',
    img: 'assets/gpt/biology5.svg',
    name: 'MOLECULAR_MUSE',
    nameEn: 'Molecular Biology',
    nameAr: 'علم الأحياء الجزيئي',
    description: 'MOLECULAR_MUSE_DESC',
    openStores: ['university'],
  },
  {
    id: 74,
    parent: 'LAW',
    img: 'assets/gpt/law1.svg',
    name: 'CONSTITUTIONAL_CODEX',
    nameEn: 'Constitutional Law',
    nameAr: 'القانون الدستوري',
    description: 'CONSTITUTIONAL_CODEX_DESC',
    openStores: ['university'],
  },
  {
    id: 75,
    parent: 'LAW',
    img: 'assets/gpt/law2.svg',
    name: 'CRIMSON_CASEBOOK',
    nameEn: 'Criminal Law',
    nameAr: 'القانون الجنائي',
    description: 'CRIMSON_CASEBOOK_DESC',
    openStores: ['university'],
  },
  {
    id: 76,
    parent: 'LAW',
    img: 'assets/gpt/law3.svg',
    name: 'CIVIL_SCRIBE',
    nameEn: 'Civil Law',
    nameAr: 'القانون المدني',
    description: 'CIVIL_SCRIBE_DESC',
    openStores: ['university'],
  },
  {
    id: 77,
    parent: 'LAW',
    img: 'assets/gpt/law4.svg',
    name: 'CONTRACT_CONSIGLIERE',
    nameEn: 'Contract Law',
    nameAr: 'قانون العقود',
    description: 'CONTRACT_CONSIGLIERE_DESC',
    openStores: ['university'],
  },
  {
    id: 78,
    parent: 'LAW',
    img: 'assets/gpt/law5.svg',
    name: 'TORT_TRAILBLAZER',
    nameEn: 'Tort Law',
    nameAr: 'قانون الضرر',
    description: 'TORT_TRAILBLAZER_DESC',
    openStores: ['university'],
  },
  {
    id: 79,
    parent: 'LAW',
    img: 'assets/gpt/law6.svg',
    name: 'PROPERTY_PARAGON',
    nameEn: 'Property Law',
    nameAr: 'قانون الملكية',
    description: 'PROPERTY_PARAGON_DESC',
    openStores: ['university'],
  },
  {
    id: 80,
    parent: 'LAW',
    img: 'assets/gpt/law7.svg',
    name: 'CORPORATE_COUNSELOR',
    nameEn: 'Corporate/Business Law',
    nameAr: 'القانون التجاري/الشركات',
    description: 'CORPORATE_COUNSELOR_DESC',
    openStores: ['university'],
  },
  {
    id: 81,
    parent: 'LAW',
    img: 'assets/gpt/law8.svg',
    name: 'INTERNATIONAL_INTERPRETER',
    nameEn: 'International Law',
    nameAr: 'القانون الدولي',
    description: 'INTERNATIONAL_INTERPRETER_DESC',
    openStores: ['university'],
  },
  {
    id: 82,
    parent: 'LAW',
    img: 'assets/gpt/law9.svg',
    name: 'ECOJUSTICE_ENVOY',
    nameEn: 'Environmental Law',
    nameAr: 'القانون البيئي',
    description: 'ECOJUSTICE_ENVOY_DESC',
    openStores: ['university'],
  },
  {
    id: 83,
    parent: 'LAW',
    img: 'assets/gpt/law10.svg',
    name: 'IDEA_ADVOCATE',
    nameEn: 'Intellectual Property Law',
    nameAr: 'قانون الملكية الفكرية',
    description: 'IDEA_ADVOCATE_DESC',
    openStores: ['university'],
  },
  {
    id: 84,
    parent: 'BUSINESS',
    img: 'assets/gpt/business1.svg',
    name: 'MARKETING_MAVERICK',
    nameEn: 'Marketing',
    nameAr: 'التسويق',
    description: 'MARKETING_MAVERICK_DESC',
    openStores: ['university'],
  },
  {
    id: 85,
    parent: 'BUSINESS',
    img: 'assets/gpt/business2.svg',
    name: 'ACCOUNTING_ANALYST',
    nameEn: 'Accounting',
    nameAr: 'المحاسبة',
    description: 'ACCOUNTING_ANALYST_DESC',
    openStores: ['university'],
  },
  {
    id: 86,
    parent: 'BUSINESS',
    img: 'assets/gpt/business3.svg',
    name: 'FISCAL_FUTURIST',
    nameEn: 'Finance',
    nameAr: 'المالية',
    description: 'FISCAL_FUTURIST_DESC',
    openStores: ['university'],
  },
  {
    id: 87,
    parent: 'BUSINESS',
    img: 'assets/gpt/business4.svg',
    name: 'HUMAN_CAPITAL_CURATOR',
    nameEn: 'Human Resources',
    nameAr: 'الموارد البشرية',
    description: 'HUMAN_CAPITAL_CURATOR_DESC',
    openStores: ['university'],
  },
  {
    id: 88,
    parent: 'BUSINESS',
    img: 'assets/gpt/business5.svg',
    name: 'OPERATIONS_ORACLE',
    nameEn: 'Operations Management',
    nameAr: 'إدارة العمليات',
    description: 'OPERATIONS_ORACLE_DESC',
    openStores: ['university'],
  },
  {
    id: 89,
    parent: 'BUSINESS',
    img: 'assets/gpt/business6.svg',
    name: 'ETHICS_EAGLE',
    nameEn: 'Business Ethics',
    nameAr: 'أخلاقيات العمل',
    description: 'ETHICS_EAGLE_DESC',
    openStores: ['university'],
  },
  {
    id: 90,
    parent: 'BUSINESS',
    img: 'assets/gpt/business7.svg',
    name: 'VENTURE_VIRTUOSO',
    nameEn: 'Entrepreneurship',
    nameAr: 'ريادة الأعمال',
    description: 'VENTURE_VIRTUOSO_DESC',
    openStores: ['university'],
  },
  {
    id: 91,
    parent: 'BUSINESS',
    img: 'assets/gpt/business8.svg',
    name: 'BORDERLESS_BUSINESS_BARD',
    nameEn: 'International Business',
    nameAr: 'الأعمال الدولية',
    description: 'BORDERLESS_BUSINESS_BARD_DESC',
    openStores: ['university'],
  },
  {
    id: 92,
    parent: 'BUSINESS',
    img: 'assets/gpt/business9.svg',
    name: 'SUPPLY_CHAIN_STRATEGIST',
    nameEn: 'Supply Chain Management',
    nameAr: 'إدارة سلسلة التوريد',
    description: 'SUPPLY_CHAIN_STRATEGIST_DESC',
    openStores: ['university'],
  },
  {
    id: 93,
    parent: 'BUSINESS',
    img: 'assets/gpt/business10.svg',
    name: 'ORGANIZATIONAL_ORACLE',
    nameEn: 'Organizational Behavior',
    nameAr: 'السلوك التنظيمي',
    description: 'ORGANIZATIONAL_ORACLE_DESC',
    openStores: ['university'],
  },
  {
    id: 94,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics1.svg',
    name: 'MICROMASTERMIND',
    nameEn: 'Microeconomics',
    nameAr: 'الاقتصاد الجزئي',
    description: 'MICROMASTERMIND_DESC',
    openStores: ['university'],
  },
  {
    id: 95,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics2.svg',
    name: 'MACROMAESTRO',
    nameEn: 'Macroeconomics',
    nameAr: 'الاقتصاد الكلي',
    description: 'MACROMAESTRO_DESC',
    openStores: ['university'],
  },
  {
    id: 96,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics3.svg',
    name: 'ECONOMETRIC_EXPLORER',
    nameEn: 'Econometrics',
    nameAr: 'الاقتصاد القياسي',
    description: 'ECONOMETRIC_EXPLORER_DESC',
    openStores: ['university'],
  },
  {
    id: 97,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics4.svg',
    name: 'DEVELOPMENT_DYNAMO',
    nameEn: 'Development Economics',
    nameAr: 'اقتصاد التنمية',
    description: 'DEVELOPMENT_DYNAMO_DESC',
    openStores: ['university'],
  },
  {
    id: 98,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics5.svg',
    name: 'CROSSBORDER_ECONOMIST',
    nameEn: 'International Economics',
    nameAr: 'الاقتصاد الدولي',
    description: 'CROSSBORDER_ECONOMIST_DESC',
    openStores: ['university'],
  },
  {
    id: 99,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics6.svg',
    name: 'LABOR_LEDGER',
    nameEn: 'Labor Economics',
    nameAr: 'اقتصاد العمل',
    description: 'LABOR_LEDGER_DESC',
    openStores: ['university'],
  },
  {
    id: 100,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics7.svg',
    name: 'PUBLIC_POLICY_PRODIGY',
    nameEn: 'Public Policy',
    nameAr: 'السياسات العامة',
    description: 'PUBLIC_POLICY_PRODIGY_DESC',
    openStores: ['university'],
  },
  {
    id: 101,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics8.svg',
    name: 'ECOECONOMIST',
    nameEn: 'Environmental Economics',
    nameAr: 'الاقتصاد البيئي',
    description: 'ECOECONOMIST_DESC',
    openStores: ['university'],
  },
  {
    id: 102,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics9.svg',
    name: 'HEALTHCARE_HARBINGER',
    nameEn: 'Health Economics',
    nameAr: 'اقتصاد الرعاية الصحية',
    description: 'HEALTHCARE_HARBINGER_DESC',
    openStores: ['university'],
  },
  {
    id: 103,
    parent: 'ECONOMICS',
    img: 'assets/gpt/economics10.svg',
    name: 'INDUSTRY_ILLUMINATOR',
    nameEn: 'Industrial Organization',
    nameAr: 'الهيكل الصناعي',
    description: 'INDUSTRY_ILLUMINATOR_DESC',
    openStores: ['university'],
  },
  {
    id: 104,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer1.svg',
    name: 'CODE_CONDUCTOR',
    nameEn: 'Programming / Software Development',
    nameAr: 'البرمجة / تطوير البرمجيات',
    description: 'CODE_CONDUCTOR_DESC',
    openStores: ['university'],
  },
  {
    id: 105,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer2.svg',
    name: 'DATA_ARCHITECT',
    nameEn: 'Data Science / Data Engineering',
    nameAr: 'علم البيانات / هندسة البيانات',
    description: 'DATA_ARCHITECT_DESC',
    openStores: ['university'],
  },
  {
    id: 106,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer3.svg',
    name: 'ALGORITHM_ARTISAN',
    nameEn: 'Algorithms',
    nameAr: 'الخوارزميات',
    description: 'ALGORITHM_ARTISAN_DESC',
    openStores: ['university'],
  },
  {
    id: 107,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer4.svg',
    name: 'SOFTWARE_SAGE',
    nameEn: 'Software Engineering',
    nameAr: 'هندسة البرمجيات',
    description: 'SOFTWARE_SAGE_DESC',
    openStores: ['university'],
  },
  {
    id: 108,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer5.svg',
    name: 'DATABASE_DETECTIVE',
    nameEn: 'Databases',
    nameAr: 'قواعد البيانات',
    description: 'DATABASE_DETECTIVE_DESC',
    openStores: ['university'],
  },
  {
    id: 109,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer6.svg',
    name: 'NETWORK_NAVIGATOR',
    nameEn: 'Computer Networks',
    nameAr: 'شبكات الحاسوب',
    description: 'NETWORK_NAVIGATOR_DESC',
    openStores: ['university'],
  },
  {
    id: 110,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer7.svg',
    name: 'OS_OVERSEER',
    nameEn: 'Operating Systems',
    nameAr: 'أنظمة التشغيل',
    description: 'OS_OVERSEER_DESC',
    openStores: ['university'],
  },
  {
    id: 111,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer8.svg',
    name: 'AI_ARCHITECT',
    nameEn: 'Artificial Intelligence',
    nameAr: 'الذكاء الاصطناعي',
    description: 'AI_ARCHITECT_DESC',
    openStores: ['university'],
  },
  {
    id: 112,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer9.svg',
    name: 'ML_MAESTRO',
    nameEn: 'Machine Learning',
    nameAr: 'تعلم الآلة',
    description: 'ML_MAESTRO_DESC',
    openStores: ['university'],
  },
  {
    id: 113,
    parent: 'COMPUTER_SCIENCE',
    img: 'assets/gpt/computer10.svg',
    name: 'HCI_HARMONIZER',
    nameEn: 'Human-Computer Interaction',
    nameAr: 'التفاعل بين الإنسان والحاسوب',
    description: 'HCI_HARMONIZER_DESC',
    openStores: ['university'],
  },
];

export const GPTAdvancedFeatures = [
  {
    id: 'testPrep',
    name: 'TEST_PREP_SUIT_UNIPREP',
    nameEn: 'Test Prep Suit (SAT, SSAT, ACT, GRE, GMAT, TOFEL)',
  },
  {
    id: 'accessAnytime',
    name: 'UNLIMITED_ACCESS_CANCEL_ANYTIME',
    nameEn: 'Unlimited Access-Cancel anytime',
  },
  {
    id: 'uploadFiles',
    name: 'UPLOAD_ATTACHED_FILES',
    nameEn: 'Upload PDF, PPT, DOC & Image files',
  },
  // {
  //   id: 'voiceText',
  //   name: 'VOICE_TO_TEXT',
  //   nameEn: 'Voice to Text',
  // },
];
